import React, { Component } from 'react';
import { Container } from 'reactstrap';
import authService from './api-authorization/AuthorizeService';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;
  constructor(props) {
    super(props)
    
    this.state = {
      filter: ''
      //btnName: Legend.props.test
    }
   
  }
  
  render () {
    return (
      <div>
        <NavMenu/>
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
